import layerEvents				from "../utils/layerEvents";
import Tool						from "../classes/Tool";
import {
	Button,
	Col,
	Row,
	Dropdown,
	Form,
	Alert
}								from "react-bootstrap";
import Select					from "react-select";
import { 
	PencilSimple,
	Lightning, 
	Windmill, 
	Clock, 
	BatteryMedium, 
	Spiral, 
	Ruler, 
	Crosshair, 
	X, 
	Info, 
	Eye, 
	Trash, 
	DotsThreeVertical, 
	Wind, 
	Calculator, 
	Warning, 
	CircleNotch, 
	Plus, 
	Circle, 
	Pencil, 
	Check,
	Palette
}								from "@phosphor-icons/react";
import {
	format_power, 
	naturalSort
}								from "../utils/functions";
import DataTable				from 'react-data-table-component';
import vindrApi					from "../utils/vindrapi";
import EditNow					from "../components/EditNow";
import DoNowButton				from "../components/DoNowButton";
import ReactDOM					from "react-dom/client";
import LayerTurbine				from "../classes/LayerTurbine";
import LayerEllipses			from "../classes/LayerEllipses";
import JobAep					from "../components/JobAep";
import DialogEditTurbines		from "../layouts/DialogEditTurbines";
import ToolTurbineDetail		from "../classes/ToolTurbineDetail";
import log						from "../utils/log";

class ToolTurbine extends Tool {

	tabIndex			= null;
	tabIndexDetail		= null;
	highlightedOnList	= [];

	type				= 'turbine';
	itemsName			= 'wtgs';
	id					= 'turbineid';
	infolayerId			= 'turbines';

	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	placeholderText		= "DbClick to set name"

	constructor(p, silent = false) {
		super();
		this.tc			= p;
		this.silent		= silent; //weather this instantiation will display sidebar
		this.newType	= this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172_7.2';
		this.newHeight	= this.tc.scenario.wtgSettings.hubHeight ? this.tc.scenario.wtgSettings.hubHeight : 150;
		this.canvas		= this.tc.map.getCanvasContainer();
		this.layerData	= LayerTurbine.data;
		this.setupStreamer('iaep');
		this.handleCalcRequestDone();
		this.statusRecalculate = this.tc.scenario.aep?.outdated ?? true;
		this.getHiddenItems();
	}
	getToolLayer() {
		return LayerTurbine;
	}
	update(){
		this.modified = false;
		//these vary every time someone changes the dropdown, so we need to update them on every scenario change
		if(!this.turbineTypes.length || !this.turbineHeights.length){
			this.turbineTypes = this.tc.scenario.turbine_types ? this.tc.scenario.turbine_types : [];
			this.turbineHeights = this.tc.scenario.hub_heights ? this.tc.scenario.hub_heights : [];
		}
		this.newType = this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172_7.2';
		this.newHeight = this.tc.scenario.wtgSettings.hubHeight ? this.tc.scenario.wtgSettings.hubHeight : 150;
	}

	init(){
			
		this.getTypes().then((res)=>{
			
			if(!res)
				return true;
			return this.getHeights(this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172_7.2');
		}).then(()=>{
			this.display();
		})
		this.setEventHandlers();
		this.setAddTurbineListener();
	}
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		this.closeContextMenu();
		this.closeEditPanel();
		vindrApi.abortRequests("turbines");
		this?.stream?.close();
	}
	setEventHandlers(){

		if(!this.tc)
			return;

		Tool.prototype.setEventHandlers.call(this);
		this.tc.map.on('contextmenu', this.handleRightClick);
		this.tc.map.on('scenario.updated', this.handleScenarioUpdated);


		this.setInOutListeners();
		this.tc.map.on('mousedown', LayerTurbine.layerId, this.onDown);
		this.tc.map.on('touchstart', LayerTurbine.layerId, this.onTouchStart);
	}
	removeEventHandlers(){
		if(!this.tc)
			return;
		Tool.prototype.removeEventHandlers.call(this);
		this.tc.map.off('contextmenu', this.handleRightClick);
		this.unsetInOutListeners();
		this.tc.map.off('mousedown', LayerTurbine.layerId, this.onDown);
		this.tc.map.off('touchstart', LayerTurbine.layerId, this.onTouchStart);
		this.tc.map.off('click', this.addTurbine);
		this.tc.map.off('scenario.updated', this.handleScenarioUpdated);
	}

	setAddTurbineListener(){
		this.setCursor("cursor-add-turbine");
		this.tc.map.on('click', this.addTurbine);
	}
	setInOutListeners(){
		this.tc.map.on('mouseenter', LayerTurbine.layerId, this.onEnter);
		this.tc.map.on('mouseleave', LayerTurbine.layerId, this.onLeave);
	}
	unsetInOutListeners(){
		this.tc.map.off('mouseenter', LayerTurbine.layerId, this.onEnter);
		this.tc.map.off('mouseleave', LayerTurbine.layerId, this.onLeave);
	}
	onUp = (e)=>{
		
		if(e.originalEvent.which != 1)
			return;
		
        const coords = e.lngLat;
		this.setInOutListeners();
        this.remCursor('cursor-grabbing');
		
		if(this.hasMoved && this.currentTurbineId){
			this.updateTurbine(this.currentTurbineId, [coords.lng, coords.lat]);
			if(this.tc.scenario.scenario_id && !isNaN(this.currentTurbineId)) {
				this.save(
					vindrApi.updateTurbine(
						this.tc.scenario.projectid,
						this.tc.scenario.scenario_id,
						this.currentTurbineId,
						coords.lat,
						coords.lng
					)
				);
			}
			this.hasMoved = false;
		}
		
		this.currentTurbineId = false;
		this.currentTurbineIdx = false;
		delete this.tc.map.mouseDown;
        // Unbind mouse/touch events
        this.tc.map.off('mousemove', this.onMove);
        this.tc.map.off('touchmove', this.onMove);
		//this.resetLayer();
    }

	onDown = (e) => {
		if(e.originalEvent.which != 1)
			return;
		e.preventDefault();
		this.unsetInOutListeners();
		this.getClickedTurbine(e);

		this.setCursor('cursor-grabbing');
		
		//set mousedown var, other events will check this
		this.tc.map.mouseDown = true;
		this.tc.map.on('mousemove', this.onMove);
		this.tc.map.once('mouseup', this.onUp);
	}
    onMove = (e) => {
		
        const coords = e.lngLat;
		this.hasMoved = true;
        // Set a UI indicator for dragging.
        this.canvas.style.cursor = 'grabbing';
		
        // Update the Point feature in `geojson` coordinates
        // and call setData to the source layer `point` on it.
        LayerTurbine.data.features[this.currentTurbineIdx].geometry.coordinates = [coords.lng, coords.lat];
        this.tc.map.getSource(LayerTurbine.sourceId).setData(LayerTurbine.data);
		
		this.handleTurbineDrag(this.currentTurbineId, [coords.lng, coords.lat])
		
    }
	onEnter = (e)=> {
		this.remCursor("cursor-add-turbine").setCursor("cursor-pointer");
		
		const id = e.features[0].id ?? e.features[0].properties.tempid;
		
		this.highlightOnMap(id);
		this.highlightOnList(id);
		
	}
	onLeave = (e)=> {
		this.remCursor("cursor-pointer").setCursor("cursor-add-turbine");
		
		this.deHighlightOnMap();
		this.deHighlightOnList(this.lastHoverId);
	}
	onTouchStart = (e)=>{
		if (e.points.length !== 1) return;

		// Prevent the default map drag behavior.
		e.preventDefault();
		this.getClickedTurbine();
		
		//set mousedown var, other events will check this
		this.tc.map.mouseDown = true;
		
		this.tc.map.on('touchmove', this.onMove);
		this.tc.map.once('touchend', this.onUp);
	}
	getClickedTurbine(e){
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		if(features[0]){
			this.currentTurbineId = features[0].id ?? features[0].properties.tempid;
			this.currentTurbineIdx = features[0].properties.idx;
		}
	}
	tName(row, index){
		return row.name;
		
	}
	highlightOnMap = (turbineid) => {
		this.lastHoverId = turbineid;
		
		this.updateMapFeatPop("turbineid", turbineid, {"hover":true});
		
	}
	deHighlightOnMap = (turbineid) => {
		
		const id = turbineid ?? this.lastHoverId;
		
		this.updateMapFeatPop("turbineid", id, {"hover":false});
	}
	
	selectOnMap = (turbineid) => {
		this.lastHoverId = turbineid;
		this.updateMapFeatPop("turbineid", turbineid, {"selected":true});
		
	}
	deselectOnMap = (turbineid) => {
		
		const id = turbineid ?? this.lastHoverId;
		
		this.updateMapFeatPop("turbineid", id, {"selected":false});
	}
	
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(id);
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id, silent) => {

		const index = this.highlightedOnList.indexOf(id);
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		if(!silent)
			this.display();
	}
	
	
	handleRowClick = (row)=>{
		
		
		var a = new ToolTurbineDetail(this, row.turbineid);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
	getHiddenItems(){
		this.hiddenItems = this.tc.scenario.wtgs.filter((a)=>{return a.invisible ?? a?.properties?.invisible}).map((a)=>{return a.turbineid ?? a.properties.turbineid});
	}
	getTypes = ()=>{
			
		const dataRequests = [
			vindrApi.getTurbineTypes(),
		];
			
		return Promise.all(dataRequests)
		.then((res)=>{
			return this.turbineTypes = res[0];
		})		
	}
	getHeights = (type)=>{
			
		const dataRequests = [
			type ? vindrApi.getTurbineHeights(type) : [],
		];
			
		return Promise.all(dataRequests)
		.then((res)=>{
			return this.turbineHeights = res[0];
		})		
	}
	closeContextMenu() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".turbineModeContextMenu")){
			a.remove();
		}
		if(!this.tc.map.hasControl(this.tc.draw.draw))
			this.tc.map.addControl(this.tc.draw.draw, 'bottom-left');
		this.contextMenuOpen = false;
	}
	handleScenarioUpdated = () => {
		this.handleCalcRequestDone();
		this.modified = false;
		
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		var id = null;
		if(features.length)
			id = features[0].id ?? features[0].properties.tempid;
		
		var wrp = document.createElement("div");
		wrp.className = "turbineModeContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		//remove the draw control because, otherwise disable dragpan doesnt work
		this.tc.map.removeControl(this.tc.draw.draw);
		this.tc.map.dragPan.disable();
		this.contextMenuOpen = true;
		this.tc.map.getContainer().appendChild(wrp);
		
		if(id){
			//right click inside marker
			ReactDOM.createRoot(wrp).render(this.contextMenu(e, id));
		}
		else{
			//right click outside marker
			ReactDOM.createRoot(wrp).render(this.contextMenuAdd(e));
		}
		
		
		
	}
	
	openEditPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "turbineEditPanel";
		
		this.closeEditPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		
		this.tc.addStylingPanel(this);

		ReactDOM.createRoot(wrp).render(<DialogEditTurbines tc={this.tc} scenario={this.tc.scenario} onClose={this.closeEditPanel} />);
		
	}

	closeEditPanel = () => {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".turbineEditPanel")){
			a?.remove();
			
			this.tc.clearStylingPanel(this);
		}
		
		
	}
	handleTurbineDrag = (id, coords) => {

		const circles = this.tc.draw.circles;
		
		//update circles
	
		//each circle has a dataset for all turbines, find the cicle for the correct turbine in each dataset and regenerate.
		circles.forEach((circle, key)=>{
			
			circle.data.features.forEach((feature, idx)=>{
				
				if(feature.properties.turbineid == id){
					
					var circle_geometry = this.tc.draw.generateCircle(coords, circle.info.radius);
					
					circle.data.features[idx].geometry = circle_geometry.features[0].geometry;
				}
			});
			
			if (circle.info.radius) {
				this.tc.map.getSource('circles_source_'+key).setData(circle.data);
			}
				
		});
		
		const el = new LayerEllipses(this.tc.draw.context);
		
		LayerEllipses.data.features.forEach((feature, idx)=>{

			if(feature.properties.turbineid == id){

				var ellipse_geometry = el.generateEllipse(coords);

				LayerEllipses.data.features[idx].geometry = ellipse_geometry.features[0].geometry;
			}
		});
		//update the data layer of the ellipse
		this.tc.map.getSource(LayerEllipses.sourceId).setData(LayerEllipses.data);
	}
	
	handleHideAllItems = () => {
		Tool.prototype.handleHideAllItems.call(this);
		this.display();
	}
	setProjFilterCheck(value){
		this.tc.map.getContainer().classList.toggle("hide-turbines", !value);
		document.querySelector("#checkbox_turbines_layer").checked = value;
	}
	handleRemoveTurbine = (e, turbineId) => {
		this.removeTurbine(e, turbineId);
		this.display();
		return true;
	}
	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.tc.scenario.wtgs ?? []).filter(t => !!t.geometry);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.turbineid === d.turbineid));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;

		this.selected.forEach((row) => {
			this.removeTurbine(null, row.turbineid);
		});
		
		const {QN} = this.tc.draw.context;
		var count = this.selected.length;
		
		QN.current.show("Deleted "+this.selected.length+" turbines", <Button variant="primary btn-sm" onClick={()=>{this.tc.undo(count)}} >Undo</Button>);
		
		

		this.selected = [];
		this.display();
	}
	updateTurbine(turbineid, coordinates) {
		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		var i = this.tc.scenario.wtgs.findIndex((elem) => elem.turbineid == turbineid);
		if(i > -1) {
			if(coordinates) {
				this.tc.scenario.wtgs[i].geometry.coordinates = coordinates;
			}
			else {
				delete this.tc.scenario.wtgs[i].geometry;
				if(typeof this.tc.scenario.wtgs[i].turbineid != 'number')
					this.tc.scenario.wtgs.splice(i, 1);
			}
			this.tc.scenario.modified = 1;
			//this.tc.setScenario(this.tc.scenario);
			//this.tc.record().add(this.tc.scenario);
		}
	}
	updateTurbineName(name, turbineid, refresh) {
		if(!this.tc.scenario || !this.tc.scenario.scenario_id)
			return;
		var i = this.tc.scenario.wtgs.findIndex((elem) => elem.turbineid == turbineid);
		if(i > -1) {
			this.tc.scenario.wtgs[i].name = name ? name : 'Turbine ' + turbineid;
			if(!isNaN(turbineid))
				this.save(vindrApi.updateTurbineName({name: name}, this.tc.scenario.projectid, this.tc.scenario.scenario_id, turbineid));
			//this.tc.scenario.modified = 1;
			//this.tc.record().add(this.tc.scenario);
		}
		if(refresh){
			this.updateMapFeatPop("turbineid", turbineid, {
				name: name ? name : 'Turbine ' + turbineid
			});
		}
	}
	handleUpdateName(newName, id){
		this.updateTurbineName(newName, id, true);
		this.display();
	}
	handleEditTurbine(e, turbineid){
		document.getElementById('edit-static-turbine-'+turbineid).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))
	}
	handleEditTurbines = () => {
		
		this.openEditPanel();
		
//		this.getContext().dialogs.setAddCircle({open:true, circle: c, onFinish: ()=>{ 
//				this.display();
//				this.tc.scenario.modified = 1;
//				this.tc.record().add(this.tc.scenario);
//				this.tc.setScenario(this.tc.scenario);
//			}
//		});
//		
		
		
	}
	handleChangeType = (e) => {
		
		this.newType = e.target.value;
		this.newHeight = 0;
		
		this.getHeights(this.newType).then(()=>{
			
			this.display();
		})
		
	}
	handleChangeHeight = (e) => {
		
		this.newHeight = e.target.value;
		
		if(this.newType && this.newHeight)
			this.handleChangeTurbineSettings(this.turbineTypes.find((t)=>{return t.turbine_type == this.newType}), this.newHeight);

		
		this.modified = true;
		this.display();
	}
	handleChangeTurbineSettings = (turbine, height) => {
		
		const projectData = this.tc.draw.context.getters.project;

		this.tc.scenario.wtgSettings.turbineType = turbine.turbine_type
		this.tc.scenario.wtgSettings.hubHeight = parseInt(height)

		//save the current set of types heighs in the scenario
		this.tc.scenario.turbine_types = this.turbineTypes;
		this.tc.scenario.hub_heights = this.turbineHeights;
		
		this.save(vindrApi.saveWtgSettings(this.tc.scenario.projectid, this.tc.scenario.scenario_id, {
			turbineType: turbine.turbine_type,
			hubHeight: parseInt(height)
		}));
		
		projectData.short_turbine_radius = turbine.short_turbine_radius;
		projectData.long_turbine_radius = turbine.long_turbine_radius;
		
		this.tc.infoLayers.current.resetSystemLayer("ellipses");
		
		this.tc.scenario.modified = 1;
		this.tc.setScenario(this.tc.scenario);

		return true;
	}
	handleDoneCalc = () => {
		
		const tasks = [
			vindrApi.getScenarioAEP(this.tc.scenario.projectid, this.tc.scenario.scenario_id), 
			vindrApi.getTurbines(this.tc.scenario.projectid, this.tc.scenario.scenario_id)
		];
		
		Promise.all(tasks).then((res)=>{
			var s = {...this.tc.scenario};
			s.aep = res[0];
			s.wtgs = res[1];
			s.modified = 0;
			
			
			this.tc.setScenario(s);
			this.statusRecalculate = s.aep.outdated;
			this.display();
		});
	}
	
	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(row.turbineid);
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{ this.closeContextMenu(); this.addTurbine(map_event);}}><Plus size={20} /> Add Turbine</button>
		);
	}
	contextMenu = (map_event, id) => {
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditTurbine(map_event, id); this.closeContextMenu();}}><Pencil size={20} /> Edit name</button>
				<button className="btn" onClick={(e)=>{this.removeTurbine(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Turbine</button>
			</>
		);
	}
	getContext(){
		return this.tc.draw.context;
	}
	getTurbine(id){
		var a = new ToolTurbineDetail(this, id);
	}
	
	save(promise){
		return super.save(promise).then((res)=>{
			
			if(!this.tc.record){
				this.tc.record = new log(this.tc);
			}
			this.tc.record.getHistory();
			return res;
		});
		
	}
	
	addTurbine = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		if(this.contextMenuOpen){
			this.closeContextMenu();
			return;
		}
		if(features.length){
			this.getTurbine(features[0].id ?? features[0].properties.tempid);
			return;
		}
		

		const id = 'temp_'+Math.random().toString(36).substr(2, 9);
		
		e.originalEvent.stopPropagation();
		var newTurbine = {
			"geometry": {
			  "coordinates": [e.lngLat.lng, e.lngLat.lat],
			  "type": "Point"
			},
			"turbineid": id,
			"name": "Turbine " +(this.tc.scenario.wtgs.length+1)
		}
		
		this.tc.scenario.wtgs.push(newTurbine);

		//this.draw.drawCircles(this.scenario);

		this.tc.scenario.modified = 1;

		this.resetLayer();
		let event = {
			scenario:this.tc.scenario,
			turbine:newTurbine
		};
		this.tc.map.fire("addTurbine", event);

		if(this.tc.scenario.scenario_id) {
			this.save(vindrApi.createTurbine(
				this.tc.scenario.projectid,
				this.tc.scenario.scenario_id,
				e.lngLat.lat,
				e.lngLat.lng,
				newTurbine.name
			)).then((res) => {
				if(res?.turbineid) {
					const idx = this.tc.scenario.wtgs.findIndex(t => t.turbineid === id);
					if(idx > -1) {
						this.tc.scenario.wtgs[idx].turbineid = res.turbineid;
						this.tc.scenario.wtgs[idx].properties.turbineid = res.turbineid;
						delete this.tc.scenario.wtgs[idx].properties.tempid
						this.tc.setScenario(this.tc.scenario);
						this.resetLayer();
					}
				}
				
			});
		}
		
	}
	removeTurbine = (e, tId) => { //tId is sent from turbine mode, e is used in eventrs from map
		
		e?.originalEvent?.stopPropagation();
		var	turbineId;
		
		if(tId != null){
			turbineId = tId;
		}
		else {
			var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});

			if(features.length){
				
				turbineId = features[0].id ?? features[0].properties.tempid;
			}
			
		}	
		if(!turbineId)
			return

		this.updateTurbine(turbineId, null);

		if(this.tc.scenario.scenario_id && !isNaN(turbineId)) {
			this.save(vindrApi.deleteTurbine(
				this.tc.scenario.projectid,
				this.tc.scenario.scenario_id,
				turbineId
			));
		}

		this.deHighlightOnList(turbineId, true);
		
		
		let event = {
			scenario:this.scenario, 
			turbine:turbineId
		};
		
		
		this.resetLayer();
		this.tc.map.fire("removeTurbine", event);
	}
	setCursor(cur){
		this.tc.map.getContainer().classList.add(cur);
		return this;
	}
	remCursor(cur){
		this.tc.map.getContainer().classList.remove(cur);
		return this;
	}
	getId(item){
		return item.turbineid ?? item?.properties?.tempid;
	}
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("turbines");
		this.tc.infoLayers.current.resetSystemLayer("ellipses");
		this.tc.draw.drawCircles(this.tc.scenario);
		
		this.highlightedOnList.forEach((id)=>{
			this.highlightOnMap(id);
		});
		
	}
	handleSelect = (e, row) => {
		
		const id = "turbineid";
		
		if(!this.selected)
			this.selected = [];
		
		
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}

	
	handleCalculateAEP = ()=>{
		
		return vindrApi.newScenarioAEP(this.tc.scenario.projectid,this.tc.scenario.scenario_id).then((resp)=>{
			return resp.id ? {success:true, data:resp}:{success:false}
		});
		
	}
	
	layerPanelMenu(){
		
		return (
			<Dropdown className="minimal">
				<Dropdown.Toggle variant="default">
					<i className="ri-more-2-fill"></i>
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item href="#" onClick={(e)=>{this.handleEditTurbines()}} className="important"><Palette weight="bold" size={16} /> Styling</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		)
	}
	handleCalcRequestDone = () => {
		if(this.silent)
			return;
		this.statusRecalculate = false;
		this.stream.connect();
	}
	getStreamerState = (json) => {
		return json.state;
	}
	render(){
		const error = this.tc.scenario.aep?.state == "error";
		const in_progress = this.tc.scenario.aep?.state == "in_progress";
		const no_aep = !this.tc.scenario.aep?.id;
		
		const outdated = !!this.tc.scenario.aep.outdated || this.tc.scenario?.outdatedAEP;
		
		var wtg = this.tc.scenario.wtgs.filter((t) => t.geometry ? true : false);
		return (
			
			<div className={"project-turbines "}>
				<div className="title">
					Turbines
					<span onClick={(e)=>{this.handleEditTurbines()}} 	className="btn btn-close alt float-end"><PencilSimple size={16} /></span>
				</div>
				<div className="scroll">
					
					<div className="content p-0">

						<DataTable
							data={wtg}
							columns={
								[
									{
										name:<Eye onClick={this.handleHideAllItems} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleItem(e, row.turbineid, undefined, false)}} id={"bndr_"+row.turbineid} data-id={row.turbineid}  className={""+(this.hiddenItems.includes(row.turbineid) || this.areAllHidden() ? 'opacity-25' : '')} size={16} />),

										width:'28px !important',
										style: {
											padding: '0',
										}
									},
									{
										name:(
											<Form.Check
												type="checkbox"
												checked={!!(this.tc.scenario.wtgs?.filter(t=>!!t.geometry).length) && this.tc.scenario.wtgs.filter(t=>!!t.geometry).every(d => this.selected && this.selected.some(s => s.turbineid === d.turbineid))}
												ref={el => { if (el) el.indeterminate = !!(this.selected?.length) && this.selected.length < (this.tc.scenario.wtgs?.filter(t=>!!t.geometry).length ?? 0); }}
												onChange={this.handleSelectAll}
											/>
										),
										selector: this.tName,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.turbineid} checked={this.selected && this.selected.some((a)=>a.turbineid == row.turbineid)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"20px",
									},
									{
										id:'name',
										name:'NAME',
										selector: this.tName,
										format: (row,index) => (<EditNow id={'turbine-'+row.turbineid} placeholder={this.placeholderText} value={this.tName(row,index)} onClick={(e)=>{this.handleRowClick(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row.turbineid)}} />),
										sortable:true,
										width:"100%",
										sortFunction: (a, b) => naturalSort(a, b, r => r.name),
									},
									{
										name:'AEP',
										selector: row => in_progress ? '' : format_power(row.aep),
										sortable:true,
										width:"80px !important",
										style: {
										}
									},
									{
										name:'WAKE LOSS',
										selector:(row)=>{return <> {in_progress ? '' : row.wakeloss ? row.wakeloss +' %' : ''} {row.wakeloss  && outdated ? <Circle size={16} color="#FEC84B" weight="fill" /> : ''}</>},
										sortable:true,
										right:true,
										width:"80px !important",
										
										style: {
											textAlign: 'right',
										},
									},
									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
												<Dropdown className="minimal">
													<Dropdown.Toggle className="p-0 px-1" variant="default">
														<DotsThreeVertical size={16} />
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditTurbine(e, row.turbineid);   }}><PencilSimple size={16} /> Edit name</Dropdown.Item>
														{/* <Dropdown.Item href="#" onClick={(e)=>{ this.handleAddCircle(e);   }}><Circle size={16} /> {this.tc.scenario.circles.length ? 'Edit' : 'Add'} circles</Dropdown.Item> */}
														<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveTurbine(e, row.turbineid); }} className="text-danger" ><Trash size={16} /> Remove turbine</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										),
										width:"20px !important",
										style: {
										}
									}
								]
							}
							defaultSortFieldId={'name'}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={row=>this.highlightOnMap(this.getId(row))}
							onRowMouseLeave={row=>this.deHighlightOnMap(this.getId(row))}
							onRowClicked={this.handleRowClick }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no turbines placed in this scenario. Please place turbines on the map to calculate the Annual Energy Production (AEP).
									</Col>
								</Row>
							}
						/>
					</div>
				</div>
				{this.selected && !!this.selected.length &&
					<Row className="p-3 batch-action">
						<Col xs="6">
							{this.selected.length} Items selected
						</Col>
						<Col xs="6 text-end">
							<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
						</Col>
					</Row>
				}
				{!!wtg.length && !in_progress &&
				<Row className="p-2 totals">
					<Col xs="2">
						Total
					</Col>
					<Col xs="3">
						{wtg.length} WTG
					</Col>
					<Col xs="3 text-end pe-0">
						{format_power(this.tc.scenario?.aep?.result) ?? 0 }
					</Col>
					<Col xs="3 text-end">
						{this.tc.scenario?.aep?.wakeloss ?? 0} %
					</Col>
				</Row>
				}
				{!!wtg.length && !in_progress &&
				<div className="content  aep">


					<Row className="basic-info mb-2">
						<Col xs="12">
							<Lightning size={16} />
							<span>Total turbine production: </span>

							{format_power(this.tc.scenario?.aep?.result) ?? 0 }
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<Wind size={16} />
							<span>Wind mean speed: </span>

							{this.tc.scenario?.aep?.mean_wind_speed ?? 0} m/s
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<BatteryMedium size={16} />
							<span>Capacity factor: </span>

							{this.tc.scenario?.aep?.capacity_factor ?? 0} %
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<Clock size={16} />
							<span>Full load hours: </span>
							{this.tc.scenario?.aep?.full_load_hours ?? 0} 
						</Col>
					</Row>
				</div>
				}
				<div className="content turbine-settings">

					{outdated &&

						<Alert variant="warning" className="with-icon m-0 mt-2 mb-4">
							<div className="icon">
								<Warning className="text-danger" weight="bold" size={16} />
							</div>
							<div className="text">
								<b>Important:</b> Turbine positions, models, or hub heights have changed. Recalculate changes to update AEP.
							</div>

						</Alert>
						
					}
					
					<Row className="mb-4">
						<Form.Group as={Col} md="6">
							<Form.Label>Turbine model</Form.Label>
							<Form.Select className="branded-select light" onChange={this.handleChangeType} value={this.newType}>
								<option value="">Select turbine model</option>
								{this.turbineTypes.map((a, idx) => {
									return <option key={idx} value={a.turbine_type}>{a.turbine_name}</option>
								})}

							</Form.Select>
						</Form.Group>
						<Form.Group as={Col} md="6">
							<Form.Label>HUB Height</Form.Label>

							<Form.Select className="branded-select light" onChange={this.handleChangeHeight}  value={this.newHeight}>
								<option value="0">Select hub height</option>
								{this.turbineHeights.map((a, idx) => {
									return <option key={idx} value={a.hub_height}>{a.hub_height} meters</option>
								})}

							</Form.Select>

						</Form.Group>
					</Row>
					
					{(outdated || no_aep ) && 
						<DoNowButton 
							iconIdle={<Calculator  size={16} />}
							btnClassName="btn-land-actions land-book mt-3"
							onClick={()=>{return this.handleCalculateAEP(); }}
							onFinish={this.handleCalcRequestDone}
							text={(this.tc.scenario.aep?.id ? 'Calculate and update AEP' : 'Start AEP calculation')}
							textLoading={'Calculating AEP...'}
						/>
					}			
					{!!this.statusText &&		
					<div className="btn btn-land-actions aep-3 mt-3">
						{this.statusIcon}
						{this.statusText}
					</div>
					}
				</div>
			</div>	
			
		);
		
	}
}

export default ToolTurbine;